module.exports = __webpack_public_path__ + "static/media/eggplant.64dba394.png";